import {mapActions} from 'vuex';
import wspdsc01ProductDescription from '../../WSPDSC01-product-description/WSPDSC01-product-description.vue';
import {CART_ITEM_TYPE, PRODUCT_IMAGE_PREFIX, SERVICE_TYPE_CODE} from '../../../common/constants/constants';

const DISPLAY_STATE = {
	CLOSED: 'CLOSED',
	OPENED_LITTLE: 'OPENED_LITTLE',
	OPENED: 'OPENED'
};

export default {
	name: 'wspp01-accordion',
	props: {
		item: {
			type: Object,
			required: true
		},
		buttonOpenedText: {
			type: String,
			required: true
		},
		buttonClosedText: {
			type: String,
			required: true
		}
	},
	components: {
		wspdsc01ProductDescription
	},
	data() {
		return {
			displayState: DISPLAY_STATE.CLOSED,
			isLongContent: false
		};
	},
	computed: {
		DISPLAY_STATE() {
			return DISPLAY_STATE;
		},

		PRODUCT_IMAGE_PREFIX() {
			return PRODUCT_IMAGE_PREFIX;
		},

		isService() {
			return this.item.type != CART_ITEM_TYPE.PRODUCT;
		},

		/**
		 * husegidoId:
		 * 1: hűségvállalás nélkül
		 * 2: 1 év
		 * 3: 2 év
		 */
		loyaltyHtml() {
			// get text
			let html = window.loyaltyTexts[this.item.szolgaltatasJellegKod];
			if (!html) console.warn('No loyaltyTexts for: ' + this.item.szolgaltatasJellegKod);

			const loyaltyTime = this.item.husegidoId - 1;
			if (loyaltyTime && html) {
				// replace loyalty time month
				html = html.replace('$1', loyaltyTime * 12);
				// replace loyalty time days
				html = html.replace('$2', loyaltyTime * 365);
				// replace monthlyfee change
				html = html.replace('$3', this.item.monthlyFeeChanged ? `erre változik ${this.item.newMonthlyFee} Ft / hó` : 'nem változik');
				return html;
			} else {
				return '';
			}
		},

		isDetailsButtonShown() {
			return this.item.szolgaltatasJellegKod == SERVICE_TYPE_CODE.FIX_NET ||
				this.item.szolgaltatasJellegKod == SERVICE_TYPE_CODE.TELEFON_MGCP;
		}
	},
	methods: {
		...mapActions('productDetailsStore', ['setModalParameters', 'toggle']),

		toggleCloseOrOpenedLittle() {
			this.displayState = this.displayState == this.DISPLAY_STATE.CLOSED ? this.DISPLAY_STATE.OPENED : this.DISPLAY_STATE.CLOSED;
			this.$nextTick(() => {
				const accordionBody = this.$el.querySelector('[data-accordion-body]');
				if (accordionBody && accordionBody.clientHeight > 350) {
					this.displayState = this.DISPLAY_STATE.OPENED_LITTLE;
					this.isLongContent = true;
				}
			});
		},

		toggleOpenOrOpenedLittle() {
			this.displayState = this.displayState == this.DISPLAY_STATE.OPENED ? this.DISPLAY_STATE.OPENED_LITTLE : this.DISPLAY_STATE.OPENED;
		},

		openDetailsModal() {
			let params = {
				title: this.item.serviceName,
				text: this.item.serviceModal
			};

			this.setModalParameters({params});
			this.toggle();
		}
	}
};



// WEBPACK FOOTER //
// ../source/modules/WSPP01-product-package/WSPP01-accordion/WSPP01-accordion.js